import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DragInsideContainerDirective } from './drag-inside-container.directive';

@NgModule({
  declarations: [DragInsideContainerDirective],
  imports: [CommonModule],
  exports: [DragInsideContainerDirective],
})
export class DragInsideContainerModule {}
